import React, { memo, useEffect, useState } from 'react';
import './Styles.css';
import FormattedAddress from './FormattedAddress';
import { ServiceClient } from '../../../../../Services/ServiceClient';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import { formatDate } from './Functions';
import { PresentationMode } from '../../../../../Enums/PresentationMode';
import AddressLogButtons from './Buttons';
import LoaderComponent from '../../../../../Elements/ids/Loader';
import ErrorMessage from '../../../../../Elements/ErrorMessage';
import { createServerErrorMessage } from '../../../../../Helpers/FormInputHelper';
import Modal from '../../../../../Elements/ids/Modal';

const AddressLog = ({ closeView, agentCode, codePrefix }) => {
  const [list, setList] = useState([]);
  const [modalMode, setModalMode] = useState(PresentationMode.Loading);
  const [error, setError] = useState(null);

  const isOpenedOnTeamLevel = agentCode === undefined;

  useEffect(() => {
    if (isOpenedOnTeamLevel) {
      ServiceClient.getTeamAddressLog(
        codePrefix,
        teamAddressLogDto => {
          setList(teamAddressLogDto.postal);
          setModalMode(PresentationMode.View);
        },
        error => {
          setModalMode(PresentationMode.Error);
          setError(createServerErrorMessage(error).message);
        }
      );
    } else {
      ServiceClient.getAgentAddressLog(
        agentCode,
        agentAddressLogDto => {
          setList(agentAddressLogDto);
          setModalMode(PresentationMode.View);
        },
        error => {
          setModalMode(PresentationMode.Error);
          setError(createServerErrorMessage(error).message);
        }
      );
    }
  }, [agentCode, codePrefix, isOpenedOnTeamLevel]);

  return (
    <Modal
      closeView={closeView}
      titleText={`${formatMessage(Messages.addressLog_title)} ${agentCode ?? codePrefix}`}
      buttons={<AddressLogButtons closeView={closeView} />}>
      {modalMode === PresentationMode.Loading ? (
        <LoaderComponent />
      ) : modalMode === PresentationMode.Error ? (
        <ErrorMessage message={error} />
      ) : (
        <div className="teamPage-addressLog-container">
          <div
            className={`common-table-row ${
              isOpenedOnTeamLevel ? 'teamPage-addressLog-tableRow-team' : 'teamPage-addressLog-tableRow-agent'
            } headerRow`}>
            <div>{formatMessage(Messages.addressLog_timeStamp)}</div>
            <div>{formatMessage(Messages.addressLog_address)}</div>
            {!isOpenedOnTeamLevel && <div>{formatMessage(Messages.common_inherited)}</div>}
            <div>{formatMessage(Messages.common_updatedBy)}</div>
          </div>
          {list?.reverse().map((item, index) => {
            return (
              <div
                className={`common-table-row ${
                  isOpenedOnTeamLevel ? 'teamPage-addressLog-tableRow-team' : 'teamPage-addressLog-tableRow-agent'
                } ${index % 2 === 1 ? 'common-modalTable-evenRow' : ''}`}
                key={index}>
                <div>{formatDate(item.updated)}</div>
                <div>
                  <FormattedAddress address={item.address} />
                </div>
                {!isOpenedOnTeamLevel && <div>{item.inherited ? 'true' : 'false'}</div>}
                <div>{item.updatedBy}</div>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
};

export default memo(AddressLog);
